
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { FormItem } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import PortSelect2 from '@/components/inputs/PortSelect2.vue';
import { MilestoneTypeEnum, MilestoneFields, MilestoneInput } from '@/types/graphql/schemaTypes';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

@Component({
  components: {
    PortSelect2,
    UtcDatePicker,
    'el-form-item': FormItem,
    'el-input': NullableInput
  }
})
export default class AirTransportation extends Vue {
  @Prop({ required: true }) private milestone!: MilestoneFields;

  private debouncer = debounce((self) => { self.$emit('update', self.milestoneInput); }, 300);
  private milestoneInput: MilestoneInput = {
    details: {
      flightNumber: get(this.milestone, 'details.flightNumber', null)
    },
    estimatedDateOfArrival: get(this.milestone, 'estimatedDateOfArrival', null),
    estimatedDateOfDeparture: get(this.milestone, 'estimatedDateOfDeparture', null),
    podId: get(this.milestone, 'pod.id', null),
    polId: get(this.milestone, 'pol.id', null)
  };

  @Watch('milestoneInput', { deep: true })
  private emitUpdate(milestoneInput: MilestoneInput) {
    this.debouncer(this);
  }
}
